import { render, staticRenderFns } from "./OtherFile.vue?vue&type=template&id=27433dcc&scoped=true"
import script from "./OtherFile.vue?vue&type=script&lang=ts"
export * from "./OtherFile.vue?vue&type=script&lang=ts"
import style0 from "./OtherFile.vue?vue&type=style&index=0&id=27433dcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27433dcc",
  null
  
)

export default component.exports